/**
 * @license BCP
 * (c) 2016 Openprovider. http://openprovider.eu
 * @author Igor Dolzhikov idolzhikov@openprovider.nl
 * License: MIT
 */
(function() {'use strict';

angular.module("prices", [])
  // regexp pattern for price value fields
  .constant("pricePattern", /^\d+(\.\d{1,2})?$/)
  // operations which allow to reproduce in price lines for domains group
  .constant("activeDomainsOperations", ['create', 'renew', 'transfer', 'trade', 'update'])
  // operations which allow to reproduce in price line for all rest groups
  .constant("activeOperations", ['create', 'renew'])
  /**
   * @ngdoc controller
   * @name createPriceLineCtrl
   * @requires $scope, $modal, $modalInstance, $filter, $location, b17Service, auth, userCache
   *
   * @description
   * Create Price Line Controller
   */
  .controller("createPriceLineCtrl", function (
    $scope, $modal, $modalInstance, $filter, $location, b17Service, auth,
    userCache, currencyMap, priceLineVersion, pricePattern,
    activeDomainsOperations, activeOperations ) {

    $scope.location = $location.path();
    $scope.ld = _;

    $scope.productLimit = 100;

    // init error and info messages
    $scope.errorMessage = null;
    $scope.infoMessage = null;

    // default close button text
    $scope.closeMessage = 'Cancel';

    // init currency map for the currency selector
    $scope.currencyMap = currencyMap;

    // add form patterns
    $scope.pricePattern = pricePattern;

    // new price line for editing
    $scope.newPrice = {
      version: priceLineVersion,
      currency: 'EUR',
      group: '',
      product: '',
      provider: '',
      article: '',
      operation: '',
      quantity: 1,
      tier : {}
    };

    // controller scope data used in view
    $scope.data = {
      price: new b17Service.price(),
      groups: [],
      products: [],
      providers: [],
    };

    // -------------
    // GET REST DATA
    // -------------

    // Get b17 config
    b17Service.getConfig().then(function (config) {
      if (config.data && config.data.data) {
        $scope.data.config = config.data.data.results[0];
        $scope.newPrice.operation = $scope.data.config.operations[0];
        $scope.newPrice.article = $scope.data.config.article;
        $scope.clearPrice();
      } else {
        checkErrorCodeMessage();
      }
    });

    // get groups
    b17Service.getGroups().then(function (groups) {
      if (groups.data && groups.data.data) {
        $scope.data.groups = groups.data.data.results;
      } else {
        checkErrorCodeMessage();
      }
    });

    // get products
    b17Service.getProducts().then(function (products) {
      if (products.data && products.data.data) {
        $scope.data.products = products.data.data.results;
      } else {
        checkErrorCodeMessage();
      }
    });

    // get providers
    b17Service.getProviders().then(function (providers) {
      if (providers.data && providers.data.data) {
        $scope.data.providers = providers.data.data.results;
      } else {
        checkErrorCodeMessage();
      }
    });

    // add new price line
    $scope.create = function () {
      // reset info/errors messages
      $scope.dismissInfo();
      $scope.dismissError();
      
      if (!$scope.newPrice.group || !$scope.newPrice.product || !$scope.newPrice.provider) {
        $scope.errorMessage = 'Please complete all required fields.';
        return;
      }

      if (!/^([a-zA-Z0-9_-]+)$/.test($scope.newPrice.article)) {
        $scope.errorMessage = 'Please use only letters, numbers and "_", "-" in option field.';
        return;
      }

      if (!isValidForm()) {
        return;
      }
      checkLogin().then(function (isLogged) {
        if (isLogged) {
          createPriceLine();
        }
      });
    };

    // close or cancel changes (do not apply changes)
    $scope.closeOrCancel = function () {
      // if already saved - close window
      if ($scope.closeMessage === 'Close') {
        $modalInstance.close('save');
      } else {
        $modalInstance.dismiss('cancel');
      }
    };

    // make changes in dependency of prime/cost
    $scope.applyPrimeCost = function() {
      $scope.newPrice.extras = parseFloat(($scope.newPrice.prime - $scope.newPrice.cost).toFixed(2));
    };

    // fill price data by zero
    $scope.clearPrice = function() {
      $scope.data.config.tiers.forEach( function(tier) {
        $scope.newPrice.tier[tier] = 0;
      });
      $scope.newPrice.prime = 0;
      $scope.newPrice.cost = 0;
      $scope.newPrice.extras = 0;
    };

    // ---------
    // SELECTORS
    // ---------

    $scope.selectGroup = function(group) {
      if ($scope.newPrice.group != group) {
        $scope.newPrice.group = group;
        $scope.newPrice.product = null;
        $scope.newPrice.provider = null;
      }
    };

    $scope.selectProduct = function(product) {
      if ($scope.newPrice.product != product) {
        $scope.newPrice.product = product;
        $scope.newPrice.provider = null;
      }
    };

    $scope.selectProvider = function(provider) {
      $scope.newPrice.provider = provider;
    };

    $scope.selectOperation = function(operation) {
      $scope.newPrice.operation = operation;
    };

    $scope.selectCurrency = function(currency) {
      $scope.newPrice.currency = currency;
    };

    // -------
    // FILTERS
    // -------

    $scope.groupFilter = function (item) {
      return !$scope.newPrice.group || 
        $scope.newPrice.group === null ||
        item.group === $scope.newPrice.group;
    };

    $scope.lazyLoadProduct = function () {
        $scope.productLimit += 100;
     };

    // clear error message
    $scope.dismissError = function() {
      $scope.errorMessage = null;
    };

    // clear info message
    $scope.dismissInfo = function() {
      $scope.infoMessage = null;
    };

    // create price line
    function createPriceLine() {
      // get regular price line
      b17Service.getPrice({
        cache: false,
        version: $scope.newPrice.version,
        group: $scope.newPrice.group,
        product: $scope.newPrice.product,
        provider: $scope.newPrice.provider,
        article: $scope.newPrice.article,
        operation: $scope.newPrice.operation,
        quantity: $scope.newPrice.quantity,
      }).then(function (prices) {
        if (prices.data && prices.data.data && prices.data.data.success) {
          $scope.errorMessage = 'The price line already exists, could not add that price line as new!';
        } else {
          if (prices.data && prices.data.data &&
            prices.data.data.success === false) {
            if (prices.data.data.error == 404) {
              $scope.data.price.version = $scope.newPrice.version;
              $scope.data.price.group = $scope.newPrice.group;
              $scope.data.price.product = $scope.newPrice.product;
              $scope.data.price.provider = $scope.newPrice.provider;
              $scope.data.price.article = $scope.newPrice.article;
              $scope.data.price.operation = $scope.newPrice.operation;
              $scope.data.price.quantity = $scope.newPrice.quantity;
              $scope.data.price.tier = {};
              $scope.data.config.tiers.forEach( function(tier) {
                $scope.data.price.tier[tier] = parseFloat($scope.newPrice.tier[tier]);
              });
              $scope.data.price.cost = parseFloat($scope.newPrice.cost);
              $scope.data.price.extras = parseFloat($scope.newPrice.extras);
              $scope.data.price.$save({
                token: auth.getToken()
              }, function (result) {
                // check the data was saved correctly
                if (result.id) {
                  $scope.infoMessage = 'The price line was saved successfuly.';
                  b17Service.getResponse().then(function (response) {
                    if (response.data && response.data.data.success) {
                      $scope.closeMessage = 'Close';
                    }
                  });
                } else {
                  checkErrorCodeMessage();
                }
              });
            } else {
              $scope.errorMessage = 'Error: (' + prices.data.data.error +
                ') ' + prices.data.data.message + ': ' + prices.data.data.info;
            }
          } else {
            checkErrorCodeMessage();
          }
        }
      });
    }

    // check if form has valid values
    function isValidForm() {
      $scope.errorMessage = null;
      if ($scope.priceForm.$invalid) {
        if ($scope.priceForm.$error.required) {
          $scope.errorMessage = 'Please complete all required fields.';
        } else {
           $scope.errorMessage = 'Please complete all fields correctly.';
        }
        return false;
      }

      return true;
    }

    // check login
    function checkLogin() {
      return auth.checkUserData().then(function(userData) {
        if (userData.UID) {
          return true;
        } else {
          var loginWindow = $modal.open({
            templateUrl: 'users/login-form.html',
            controller: 'loginFormCtrl',
            size: 'md',
            backdrop: 'static'
          });
          loginWindow.result.then(function (message) {
            console.log(message);
          });
          return false;
        }
      });   
    }

    function checkErrorCodeMessage() {
      if (userCache.get('lastErrorCode')) {
        $scope.errorMessage = 'Error: (' + userCache.get('lastErrorCode') +
          ') ' + userCache.get('lastErrorMessage') + ': ' + userCache.get('lastErrorInfo');
      } else {
        $scope.errorMessage = 'Unknown error, please check connection to service.';
      }
    }

  });

})();
